module.exports = __webpack_public_path__ + "img/kitware-logo.689d3e95.svg";